// ─── GlobalStyles.jsx ─────────────────────────────────────────────────────────
// Scoped font styles — applied only to elements inside [data-theme="ooe-v1"].
// Does NOT touch body, #root, or any existing app styles.
//
// Usage:
//   1. GlobalStyles is mounted ONCE in App.js (both authenticated shells) —
//      do not render it again per page.
//   2. Add data-theme="ooe-v1" to the outermost wrapper of your feature
//      (the app shell's header/sidebar and the per-route page wrappers do).
//
// Example in AccountSetup/AccountSetup.styles.js:
//   export const PageWrapper = styled.div`
//     &[data-theme="ooe-v1"], [data-theme="ooe-v1"] & { ... }
//   `
//   — or simply set it via the attribute on the wrapper div.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react'
import {Global, css} from '@emotion/react'
import {theme} from './theme'

export function GlobalStyles() {
  return (
    <Global
      styles={css`
        /* ── Font import ──────────────────────────────────────────────────── */
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        /* ── Scoped to feature wrapper only ──────────────────────────────── */
        /* Everything inside data-theme="ooe-v1" gets Inter.           */
        /* Nothing outside is touched — existing app styles are safe.         */

        [data-theme='ooe-v1'] {
          font-family: ${theme.fonts.body};
          //   font-size: ${theme.fontSizes.base};
          //   font-weight: ${theme.fontWeights.regular};
          //   color: ${theme.colors.text.primary};
          //   line-height: 1.5;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        /* ── Headings inside the feature ─────────────────────────────────── */
        [data-theme='ooe-v1'] h1,
        [data-theme='ooe-v1'] h2,
        [data-theme='ooe-v1'] h3,
        [data-theme='ooe-v1'] h4,
        [data-theme='ooe-v1'] h5,
        [data-theme='ooe-v1'] h6 {
          font-family: ${theme.fonts.body};
          //   font-family: ${theme.fonts.heading};
          //   font-weight: ${theme.fontWeights.semibold};
          //   line-height: 1.25;
          margin: 0;
        }
        [data-theme='ooe-v1'] label {
          font-family: ${theme.fonts.heading};
          margin: 0;
        }

        /* ── Code/mono inside the feature ────────────────────────────────── */
        [data-theme='ooe-v1'] code,
        [data-theme='ooe-v1'] pre,
        [data-theme='ooe-v1'] kbd {
          font-family: ${theme.fonts.mono};
          //   font-size: 0.9em;
        }

        /* ── Form elements — browsers skip font inheritance by default ────── */
        [data-theme='ooe-v1'] input,
        [data-theme='ooe-v1'] button,
        [data-theme='ooe-v1'] textarea,
        [data-theme='ooe-v1'] select {
          font-family: ${theme.fonts.body};
          //   font-family: inherit;
          //   font-size: inherit;
        }
      `}
    />
  )
}
